/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    DatalistAnagrafica,
    Paginator,
    PianoInterventi,
    Progetto
} from '@models';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';
import { CurrencyMaskInputMode } from 'ngx-currency';

@Component({
    selector: 'app-toolkit-opera-modal-piano-interventi',
    templateUrl: './modal-piano-interventi.component.html',
})
export class ToolkitGestioneOperaModalPianoInterventiComponent implements OnInit {
    
    @Input() canEdit: boolean;
    @Input() azione: string;
    @Input() params: PianoInterventi;
    @Input() datalist: DatalistAnagrafica;
    @Input() currentProgetto: Progetto;

    public criteriaForm: FormGroup;
    public progettoForm: FormGroup;
    public tableDataProgetto: Progetto[] = [];
    public paginatorProgetto: Paginator = new Paginator();
    public modalCreaProgetto: NgbModalRef;
    readonly natural = CurrencyMaskInputMode.NATURAL;

    get ricercaProgettoDTO() { return this.criteriaForm.controls['ricercaProgettoDTO'] as FormGroup; }
    get inserisciProgettoDTO() { return this.criteriaForm.controls['inserisciProgettoDTO'] as FormGroup; }
    get pianoInterventoDTO() { return this.criteriaForm.controls['pianoInterventoDTO'] as FormGroup; }
    
    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private fb: FormBuilder,
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            pianoInterventoDTO: this.fb.group({
                idPianoIntervento: this.fb.control(null),
                idOpera: this.fb.control(this.operaService.operaSession.idOpera, Validators.required),
                dataPrevista: this.fb.control(null),
                enteEsecutore: this.fb.control(null),
                dataEsecuzione: this.fb.control(null),
                descrizione: this.fb.control(null),
                note: this.fb.control(null),
                idProgetto: this.fb.control(null, Validators.required),
                idTipoIntervento: this.fb.control(null, Validators.required),
            }),
            ricercaProgettoDTO: this.fb.group({
                denominazione: this.fb.control(null),
                sigla: this.fb.control(null),
                // progettista: this.fb.control(null),
                cup: this.fb.control(null),
                codiceUnivoco: this.fb.control(null),
            }),
            inserisciProgettoDTO: this.fb.group({
                idProgetto: this.fb.control(null),
                idStato: this.fb.control(null),
                denominazione: this.fb.control(null, Validators.required),
                descrizione: this.fb.control(null),
                sigla: this.fb.control(null),
                // progettista: this.fb.control(null),
                studio: this.fb.control(null),
                impresa: this.fb.control(null),
                importoEuro: this.fb.control(null),
                amministrazioneAggiudicatrice: this.fb.control(null),
                cup: this.fb.control(null, Validators.required),
                codiceUnivoco: this.fb.control(null),
                vincoliPai: this.fb.control(null),
                accessoWebLimitato: this.fb.control(null),
                annoEsecuzione: this.fb.control(null,[Validators.pattern('^(19|20)[0-9]{2}$')]),
                note: this.fb.control(null),
            })
        });
        if (this.params) {
            this.pianoInterventoDTO.patchValue(this.params);
        }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
    }

    public savePianoInterventi() {
        if (this.pianoInterventoDTO.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        } else if(this.criteriaForm.get('annoEsecuzione')?.invalid) {
            this.utilsService.showWarning('Inserire un anno valido compreso tra il 1900 e il 2099');
            return;
        } 
        this.activeModal.close(this.pianoInterventoDTO);
    }

    /* Progetto: ricerca */
    public resetFormRicercaProgetto() {
        this.paginatorProgetto.resetPaginator();
        this.tableDataProgetto = [];
        this.pianoInterventoDTO.controls['idProgetto'].setValue(null);
        this.ricercaProgettoDTO.reset();
    }
    
    public submitFormRicercaProgetto(fromBtn?: boolean) {
        if(fromBtn) {
            this.paginatorProgetto.resetPaginator();
        }
        this.progettoService.search(this.ricercaProgettoDTO.getRawValue(), this.paginatorProgetto.getQueryPaginator([])).subscribe(response => {
            this.tableDataProgetto = [...response.content];
            this.paginatorProgetto.setTotalPage(response.totalElements);
        });
    }
    public onPageChangeProgetto($event: number) {
        this.paginatorProgetto.page = $event;
        this.submitFormRicercaProgetto();
    }
    
    public selezionaProgetto(item: Progetto) {
        this.currentProgetto = item;
        this.pianoInterventoDTO.controls['idProgetto'].setValue(item.idProgetto);
    }

    /* Progetto: inserimento */
    public creaProgetto(content: any) {
        this.modalCreaProgetto = this.modalService.open(content, { size: 'xl' });
    }

    public creaProgetto_confirm() {
        if (this.inserisciProgettoDTO.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            this.inserisciProgettoDTO.markAllAsTouched();
            return;
        } else if(!this.progettoService.isValidCUP(this.inserisciProgettoDTO.get('cup')?.value)) {
            this.criteriaForm.get('cup')?.setErrors({});
            return;
        }
        this.progettoService.create(this.inserisciProgettoDTO.getRawValue()).subscribe(response => {
            this.selezionaProgetto(response);
            this.modalCreaProgetto.close();
        });
    }

}
